import { createSelector } from 'reselect';

import { selectGetConfigValue } from '@pressreader/config';

export const selectBookmarksEnabled = createSelector(selectGetConfigValue, (getConfigValue): boolean => {
    return getConfigValue<boolean>('ui.Bookmarks.enable', true);
});
